import { useSelector } from "react-redux";
import { selectCurrentUserRole } from "../features/auth/authSlice";
import { useEffect, useMemo, useState } from "react";
import { roleTabOrder, tabsData } from "../data/data-products";

export function useRoleTabs() {
    
    const role = useSelector(selectCurrentUserRole)?.toLowerCase() ?? "";
    
    const filteredTabs = useMemo(() => {
        const order = roleTabOrder[role] || [];
        
        return tabsData
            .filter(tab => tab.allowedRoles.includes(role))
            .sort((a, b) => {
                return order.indexOf(a.tabName) - order.indexOf(b.tabName);
            });
    }, [role]);

    const [activeTab, setActiveTab] = useState<number | null>(null);
    
    useEffect(() => {
        if (!filteredTabs.length) return;

        if (activeTab !== null) return;

        const defaultTab = filteredTabs.find(tab =>
            tab.defaultForRoles?.includes(role)
        );

        setActiveTab(defaultTab?.tabId ?? filteredTabs[0].tabId);
    }, [role, filteredTabs, activeTab]);

    const activeTabData = filteredTabs.find(tab => tab.tabId === activeTab);
    const ActiveComponent = activeTabData?.component;

    return {
        role,
        filteredTabs,
        activeTab,
        setActiveTab,
        ActiveComponent,
    };
}